"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/*
start alchemy2java
cd ../alchemy2-tools
node --loader ts-node/esm src/descriptor2ts.ts --epr http://127.0.0.1:50975/metadata --dir ../fe-shared/src/types/dbs/api

git clone https://github.com/doubleaxe/wsdl-tsclient
npm install && npm run build
node dist/src/cli.js ../../../../UI/data/wsdl-client/CenturyWebService.wsdl -o src/types/century/api --useWsdlTypeNames --modelNameSuffix Raw --stripNamespacePrefix --allowRequestStringTypes
*/
tslib_1.__exportStar(require("./utils"), exports);
//# sourceMappingURL=index.js.map